export function isDatabaseReachabilityError(error: string): boolean {
  const normalized = error.toLowerCase()
  return [
    'admin account check timed out',
    'connect_timeout',
    'connection refused',
    'could not connect to database',
    'database connection failed',
    'database was not reachable',
    'econnrefused',
    'econnreset',
    'enotfound',
    'etimedout',
    'no route to host',
    'timeout',
    'timed out'
  ].some((pattern) => normalized.includes(pattern))
}
